// extracted by mini-css-extract-plugin
export var typingIndicator = "_pk-0";